<template>
    <div class="card asset-preview non-shareable">
        <div class="thumbnail">
            <img :src="image_src" :alt="title">
        </div>

        <div class="card-body" style="position: relative">
            <div class="title mb-2" :id="prefix + 'asset-title' + id">
                {{ short_title }}
            </div>

            <b-tooltip
                v-if="(short_title != title)"
                :target="prefix + 'asset-title' + id"
                triggers="hover"
            >
                {{ title }}
            </b-tooltip>

            <div>
                <span
                    class="asset-info stay"
                    :id="prefix + 'asset-info' + id"
                >
                    <span class="float-right" style="position: relative; top: 2px">{{ id }}</span>
                    <span
                        v-if="extension"
                        class="badge badge-primary font-size-11"
                        style="text-transform: uppercase"
                    >
                        {{ extension }}
                    </span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data'],
        data () {
            return {
                id: 0,
                image_src: '/images/file-icon.png',
                title: '',
                short_title: '',
                extension: null,
                file_type: null,
                prefix: 'non-shareable-'
            }
        },
        mounted () {
            this.updateData(this.data);
            var vm = this;
            $(window).resize(function () {
                vm.short_title = vm.title;
                setTimeout(function () {
                    vm.fitTitle();
                }, 500);
            });
        },
        watch: {
            data: function (val) {
                if (val) {
                    this.updateData(val);
                }
            }
        },
        methods: {
            updateData: function (data) {
                if (data) {
                    this.id = data.id;
                    this.title = data.title || data.filename;
                    this.short_title = data.title || data.filename;
                    this.extension = data.file_extension || null;
                    if (!this.extesion && data.filename) {
                        const parts = data.filename.split('.');
                        this.extension = parts[parts.length - 1];
                    }
                    this.file_type = data.file_type;
                    if (data.preview) {
                        this.image_src = data.preview;
                    }
                    this.getPreviewImage();
                    var vm = this;
                    setTimeout(function () {
                        vm.fitTitle();
                    }, 500);
                }
            },
            getPreviewImage: function () {
                if (this.image_src != '/images/file-icon.png') {
                    return null;
                }
                /**
                 * Send request to API.
                 */
                let size = (this.extension == 'svg') ? 'svg' : 'lowres';
                if (this.file_type == 'image/gif') {
                    size = 'highres';
                }
                const path = '/resource/' + this.id + '/preview/' + size;
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + path;
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    if (response.data.image_src) {
                        vm.image_src = response.data.image_src;
                    }
                })
                .catch(function (error) {
                    // Show any errors?
                });
            },
            fitTitle: function () {
                if (!$('#' + this.prefix + 'asset-title' + this.id)[0]) {
                    var vm = this;
                    setTimeout(function () {
                        vm.fitTitle();
                    }, 200);

                    return null;
                }
                if ($('#' + this.prefix + 'asset-title' + this.id)[0].scrollHeight > 20) {
                    let words = this.short_title.split(' ');
                    words.pop();
                    if (words.length > 0) {
                        this.short_title = words.join(' ') + '...';
                        var vm = this;
                        setTimeout(function () {
                            vm.fitTitle();
                        }, 200);
                    }
                }
            }
        }
    }
</script>
<style scoped>
    .asset-preview.non-shareable {
        color: #495057;
    }

    .asset-preview.non-shareable .thumbnail {
        height: 132px;
    }

    .asset-preview.non-shareable .thumbnail img {
        max-height: 130px;
    }

    .asset-preview:hover .card-body .asset-info.stay {
        opacity: 1;
    }
</style>
